'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../expression/index.js');
var operators_enum = require('../expression/operators.enum.js');

/**
 * Filter form configurations.
 *
 * @export
 * @returns {ExpressionFormConfig}
 */
function getFilterFormConfig() {
  return {
    pageType: 'PathFilter',
    supportOptions: ['NullCondition', 'NullExpression', 'IntConstant', 'RealConstant', 'BoolConstant', 'StringConstant', 'DatetimeConstant', 'IntParam', 'RealParam', 'BoolParam', 'StringParam', 'DatetimeParam', 'AliasReference', 'AttrVariable', 'AttrVariableWithAlias', 'ArithmeticExpression', operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Plus, operators_enum.RelationalOperator.Equal, operators_enum.RelationalOperator.Larger, operators_enum.RelationalOperator.LargerOrEqual, operators_enum.RelationalOperator.NotEqual, operators_enum.RelationalOperator.Smaller, operators_enum.RelationalOperator.SmallerOrEqual, operators_enum.PredicateOperator.And, operators_enum.PredicateOperator.Not, operators_enum.PredicateOperator.Or]
  };
}

/**
 * Aggregation form configurations.
 *
 * @export
 * @returns {ExpressionFormConfig}
 */
function getAggregationFormConfig() {
  return {
    pageType: 'PathAggregation',
    isExpression: true,
    supportOptions: ['NullExpression', 'IntConstant', 'RealConstant', 'BoolConstant', 'StringConstant', 'DatetimeConstant', 'IntParam', 'RealParam', 'BoolParam', 'StringParam', 'DatetimeParam', 'AliasReference', 'AttrVariable', 'AttrVariableWithAlias', 'Function', 'ArithmeticExpression', operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Plus],
    supportFunctions: [operators_enum.FunctionType.Count, operators_enum.FunctionType.DistinctCount, operators_enum.FunctionType.Sum, operators_enum.FunctionType.Min, operators_enum.FunctionType.Max, operators_enum.FunctionType.Avg, operators_enum.FunctionType.Collect, operators_enum.FunctionType.DistinctCollect]
  };
}

/**
 * Order by form configurations.
 *
 * @export
 * @returns {ExpressionFormConfig}
 */
function getOrderByFormConfig() {
  return {
    pageType: 'PathOrderBy',
    isExpression: true,
    supportOptions: ['NullExpression', 'IntConstant', 'RealConstant', 'StringConstant', 'IntParam', 'RealParam', 'StringParam', 'AttrVariable', 'ArithmeticExpression', operators_enum.ArithmeticOperator.Divide, operators_enum.ArithmeticOperator.Minus, operators_enum.ArithmeticOperator.Mod, operators_enum.ArithmeticOperator.Multiply, operators_enum.ArithmeticOperator.Plus]
  };
}

exports.getAggregationFormConfig = getAggregationFormConfig;
exports.getFilterFormConfig = getFilterFormConfig;
exports.getOrderByFormConfig = getOrderByFormConfig;
